module.exports = __webpack_public_path__ + "assets/img/selectMode.d4873174.jpg";